<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <span>主动领取活动</span>
      </div>

      <el-form :inline="true" :model="formSearch" class="demo-form-inline" size="mini">
        <el-form-item label="活动名称">
          <el-input v-model="formSearch.activityName" placeholder="活动名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="handleOpenOrClosed">创建活动</el-button>
          <el-button type="warning" @click="handleUploadOpenOrClosed">批量导入</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list" size="mini">
        <el-table-column prop="activityName" label="活动名称"></el-table-column>
        <el-table-column label="活动开始日期">
          <template slot-scope="scope">
            <span>{{formatActiviDate(scope.row.startDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="活动结束日期">
          <template slot-scope="scope">
            <span>{{formatActiviDate(scope.row.endDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="activityState" label="活动状态" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.activityState ==0">待上线</span>
            <span v-if="scope.row.activityState ==1">已上线</span>
            <span v-if="scope.row.activityState ==2">已结束</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click="handleShowClick(scope.row)" type="text" size="small">详情</el-button>
            <el-divider v-if="scope.row.activityState === 0" direction="vertical"></el-divider>
            <el-button v-if="scope.row.activityState === 0" type="text" size="small" @click="handleLineClick(scope.row)">上线</el-button>
            <el-divider v-if="scope.row.activityState === 1" direction="vertical"></el-divider>
            <el-button v-if="scope.row.activityState === 1" type="text" size="small" @click="handleUnLineClick(scope.row)">下线</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination style="float:right;margin:10px" @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageresult.pageSize"
        layout="total, prev, pager, next"
        :total="pageresult.totalSize">
      </el-pagination>
    </el-card>

    <sam-activity-add :dvisible="dvisible"></sam-activity-add>
    <sam-activity-show :dvisible="dsvisible" :showForm="obj"></sam-activity-show>
    <sam-activity-upload :visible="cvisible"></sam-activity-upload>
  </div>
</template>

<script>
import activityAdd from '../components/custom/activityAdd'
import activityShow from '../components/custom/activityShow'
import activityUpload from '../components/custom/activityUpload'
import moment from 'moment'
export default {
  components:{
      'sam-activity-add':activityAdd,
      'sam-activity-show':activityShow,
      'sam-activity-upload':activityUpload
  },
  data () {
    return {
      dvisible:false,
      dsvisible:false,
      cvisible:false,
      list:[],
      pageresult:{},
      obj:{},
      formSearch: {
        pageNum:1
      }
    }
  },
  created(){
    this.query();
  },
  methods: {
    query(){
      let _this = this;
      let info = this.$store.state.userInfo;
      _this.formSearch.czybh = info.userbh;
      _this.$ajax({
        url:"coupon-market/activity_active/query",
        async:false,
        data:_this.formSearch,
        token:window.sessionStorage.getItem('token'),
        success:function(response){
          if (response.code== 0) {
            _this.list = response.data.content;
            _this.pageresult = response.data;
          }else{
            _this.$message.error(response.message);
          }
        }
      })
    },
    formatActiviDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    handleLineClick(row){
      let _this = this;
      _this.$confirm('此上线操作, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.$ajax({
            url:"coupon-market/activity_active/line",
            async:false,
            methods:'GET',
            data:{'id':row.id},
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code==0) {
                _this.query();
              }else{
                _this.$message.error(response.message);
              }
            },
            error:function(){
              _this.$message.error("请求失败");
            }
          })
        });
    },
    handleUnLineClick(row){
      let _this = this;
      _this.$confirm('此下线操作, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.$ajax({
            url:"coupon-market/activity_active/unLine",
            async:false,
            methods:'GET',
            data:{'id':row.id},
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code==0) {
                _this.query();
              }else{
                _this.$message.error(response.message);
              }
            },
            error:function(){
              that.$message.error("请求失败");
            }
          })
        });
    },
    handleCurrentChange(pageNum) {
      this.formSearch.pageNum = pageNum;
      this.query();
    },
    handleOpenOrClosed(){
      this.dvisible = !this.dvisible;
    },
    handleShowOpenOrClosed(){
      this.dsvisible = !this.dsvisible;
    },
    handleUploadOpenOrClosed(){
      this.cvisible = !this.cvisible;
    },
    //详细展示
    handleShowClick(row){
      this.handleShowOpenOrClosed();
      this.obj = row;
      this.obj.activityDate = [row.startDate,row.endDate];
      console.log(row);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/merch/mer_activity_active.vue